// extracted by mini-css-extract-plugin
module.exports = {"root":"ObjectExtendedSubRow_root__ng21O","indicator":"ObjectExtendedSubRow_indicator__200HN"};